import { useTheme } from "capsule"
import { TextSeparator } from "capsule/components/TextSeparator"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet, View } from "react-native"
import { Text } from "react-native-paper"

import LoginForm from "../../components/LoginForm"
import { RegisterCodeAlreadyUsedNS } from "../../features/i18n/constants"

const RegisterCodeAlreadyUsedScreen = () => {
  const {
    colors: {
      surface: { background },
    },
    dimensions: { spacing },
  } = useTheme()
  const { t } = useTranslation(RegisterCodeAlreadyUsedNS)
  const s = useMemo(
    () => ({
      view: [
        styles.view,
        {
          backgroundColor: background,
          paddingHorizontal: spacing * 2,
          paddingVertical: spacing,
        },
      ],
      section: styles.section,
      bold: [styles.bold, { fontSize: 14 }],
    }),
    [background, spacing],
  )
  return (
    <View style={s.view}>
      <Text style={s.bold}>{t("alreadyHaveAnAccount")}</Text>
      <Text>{t("connectYou")}</Text>
      <LoginForm />
      <View>
        <TextSeparator text={t("or")} />
      </View>
      <View style={s.section}>
        <Text style={s.bold}>{t("dontHaveAnAccount")}</Text>
        <Text>{t("usedByError")}</Text>
        <View style={styles.blueSection}>
          <Text>
            <Text style={styles.bold}>{t("contactSurgeonBold")}</Text>{" "}
            <Text>{t("contactSurgeon")}</Text>
          </Text>
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
    gap: 8,
    display: "flex",
    justifyContent: "flex-start",
  },
  bold: {
    fontWeight: "bold",
  },
  section: {
    paddingVertical: 20,
    gap: 8,
  },
  blueSection: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 8,
    justifyContent: "center",
    alignItems: "center",
  },
})

export default RegisterCodeAlreadyUsedScreen
